// Sentry context tagging — adds user + tenant + role to every error report so
// production errors are scoped to the right tenant/user when triaging.
//
// Wired from AuthContext after sign-in / tenant resolution and on sign-out.

import { setUser, setTag } from './sentryClient';

/**
 * Attach the current user + tenant + role to all subsequent Sentry events.
 *
 * Pass the most-recent values you have. Pass null/undefined for any field that
 * isn't resolved yet — Sentry only updates the fields that are non-null.
 */
export function setSentryContext({ user, tenantId, role } = {}) {
  try {
    if (user && user.id) {
      setUser({
        id: user.id,
        email: user.email || undefined,
      });
    }
    if (tenantId) {
      setTag('tenant_id', tenantId);
    }
    if (role) {
      setTag('role', role);
    }
  } catch {
    // Sentry SDK calls should never throw, but if they do never let it
    // propagate — this helper is best-effort metadata.
  }
}

/**
 * Clear all user + tenant context. Call on sign-out so subsequent anonymous
 * errors don't get attributed to the previous user.
 */
export function clearSentryContext() {
  try {
    setUser(null);
    setTag('tenant_id', undefined);
    setTag('role', undefined);
  } catch {
    /* swallow */
  }
}
